export default __webpack_public_path__ + "static/media/logo.272e59e4.png";